import { appConfig } from '../settings';

export const useCurrencyShortCodeById = (id: string): string | undefined => {
    return appConfig.currency.find((i) => i.id === id)?.shortCode;
};
